import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import PagoOrden from "../components/content/componente_orden_de_pago";
import { format } from "date-fns";
import Swal from "sweetalert2";

class Tramites extends React.Component {

  constructor(props) {
    super(props);

    this.handleSolicitudPage = this.handleSolicitudPage.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClickCorrection = this.handleClickCorrection.bind(this);
    this.handleEstablecimientoPage =this.handleEstablecimientoPage.bind(this);
    this.handleClickEstablecimiento = this.handleClickEstablecimiento.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleProductoPage =this.handleProductoPage.bind(this);
    this.handleClickProductos = this.handleClickProductos.bind(this);
    this.handleConstanciasPage = this.handleConstanciasPage.bind(this);
    this.handleMedicoVeterinarioPage =this.handleMedicoVeterinarioPage.bind(this);
    this.handleCertificadosPage =this.handleCertificadosPage.bind(this);
    this.handleMVCorrection = this.handleMVCorrection.bind(this);
    this.handleClickConstancias = this.handleClickConstancias.bind(this);
    this.handleClickDocRefrenda = this.handleClickDocRefrenda.bind(this);
    this.handleClickCertificados = this.handleClickCertificados.bind(this);
    this.handleClickPrecertificadoCE = this.handleClickPrecertificadoCE.bind(this);
    this.handlePreCertificadosPage = this.handlePreCertificadosPage.bind(this);
    this.handleClickPrecertificados = this.handleClickPrecertificados.bind(this);

    this.state = {
      nivelUsuario: localStorage.nivel_actual,
      modalOrden: false,
      working: true,
      regentes: [],
      establecimientos: [],
      productos: [],
      constancias: [],
      medico_veterinario: [],
      certificados: [],
      precertificados: [],
      precertificadosCE: [],
      rc: 0,
      orden: {
        id: "",
        //logo: "",
        folio_orden: "",
        nombre_cliente: "",
        cantidad_num: "",
        cantidad_tex: "",
        servicio: "",
        //firma: ""
      },
      date: format(new Date(), "dd/MM/yyyy"), //new Date().toLocaleDateString(),
      actividad_establecimiento: Api.loadCatalogue("cat_actividad"),
      paginaActual: 0,
      paginas: 0,
      registros: 0,

      paginaActual_e: 0,
      paginas_e: 0,
      registros_e: 0,

      paginaActual_p: 0,
      paginas_p: 0,
      registros_p: 0,

      paginaActual_c: 0,
      paginas_c: 0,
      registros_c: 0,

      paginaActual_mv: 0,
      paginas_mv: 0,
      registros_mv: 0,

      paginaActual_cer: 0,
      paginas_cer: 0,
      registros_cer: 0,

      paginas_pre: 0,
      registros_pre: 0,
      paginaActual_pre: 0,

      paginas_prece: 0,
      registros_prece: 0,
      paginaActual_prece: 0,

      activeTab: "1",
      collapse: [
        { id: 1, collapse: true },
        { id: 2, collapse: false },
        { id: 3, collapse: false },
        { id: 4, collapse: false },
        { id: 5, collapse: false },
        { id: 6, collapse: false },
        { id: 7, collapse: false },
      ],
      //Busquedas
      buscar: {},
      buscarEstablecimientos: {},
      buscarProductos: {},
      buscarConstancias: {},
      buscarMedicoV: {},
      buscarCertificado: {},
      buscarPrecertificado: {},
      buscarPrecertificadoce: {},
      accionCombo: Api.loadCatalogue("cat_accion"),
      tipoRegenteCombo: Api.loadCatalogue("cat_tipo_regente"),
      estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
      tipo_establecimiento: Api.loadCatalogue("cat_tipo_establecimiento"),
      cat_tipo_producto: Api.loadCatalogue("cat_tipo_producto"),
      tipo_constancia: Api.loadCatalogue("cat_constancia_tipo"),
      actividades: Api.loadCatalogue("cat_actividad"),
    };
    this.toggleCollapse = this.toggleCollapse.bind(this);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggleCollapse(index) {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({
      collapse: newArray,
    });
  }

  componentDidMount() {
     // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    this.setSolicitudesPage(1);
    this.setEstablecimientosPage(1);
    this.setProductosPage(1);
    this.setConstanciasPage(1);
    this.setMedicoVeterinarioPage(1);
    this.setCertificadosPage(1);
    this.setPrecertificadosPage(1);
    this.setPrecertificadosCEPage(1);

    let f_busqueda_r = Api.form({
      target: "#busqueda_r",
      nombre: "busqueda_Regente",
      elementClass: "form-control",
      elements: [
          {
            input: {
                type: "text",
                name: "folio_solicitud",
                label: "Folio",
                placeHolder: "Ingresa el folio de la solicitud",
                cols: 3,
            }
          },{
              select: {
                  type: "text",
                  name: "accion",
                  label: "Solicitud",
                  cols: 3,
                  render:me=>{
                    me.innerHTML=`<option value="">Seleccione</option>`;
                    this.state.accionCombo.forEach(s=>{
                      me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                    }) 
                  }
              }
          },{
              input: {
                  type: "date",
                  name: "fecha",
                  label: "Fecha desde",
                  cols: 3,
                  value: ""
              }
          },{
            input: {
                type: "date",
                name: "fecha2",
                label: "Fecha hasta",
                cols: 3,
                value: ""
            }
          },{
            select: {
                type: "text",
                name: "tipo",
                label: "Tipo regente",
                placeHolder: "Tipo regente",
                cols: 6,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  this.state.tipoRegenteCombo.forEach(s=>{
                    me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                  })
                })
            }
          },{
            select: {
                type: "text",
                name: "estatus",
                label: "Estado",
                placeHolder: "Estado",
                cols: 4,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  let array_mostrar = [1,2,3,4,5,6,8,12];
                    this.state.estatusTramiteCombo.forEach(s=>{
                      if(array_mostrar.includes(parseInt(s.id))){
                        me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                      }
                    })
                })
            }
          },{
            button: {
              name: "buscar",
              class: "form-control btn-orange",
              icon: "fa fa-search",
              cols: 2,
              text: "Buscar",
              click: (e) => {
                this.setState({ buscar: f_busqueda_r.data() });
                this.setSolicitudesPage(1);
              }
            }
          }
      ],
      
    });

    let f_busqueda_e = Api.form({
      target: "#busqueda_e",
      nombre: "busquedaEstablecimiento",
      elementClass: "form-control",
      elements: [
            {
              input: {
                  type: "text",
                  name: "folio_solicitud",
                  label: "Folio",
                  placeHolder: "Ingresa el folio de la solicitud",
                  cols: 4,
              }
          }, {
            input: {
                type: "text",
                name: "razon_social",
                label: "Razón social",
                placeHolder: "Ingresa la razón social del establecimiento",
                cols: 4,
            }
        },{
              select: {
                  type: "text",
                  name: "nombre_servicio",
                  label: "Solicitud",
                  cols: 4,
                  render:me=>{
                    me.innerHTML=`<option value="">Seleccione</option>`;
                    this.state.accionCombo.forEach(s=>{
                      me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                    }) 
                  }
              }
          },{
            select: {
                cols: 6,
                name: "actividad",
                label: "Actividad",
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                        this.state.actividad_establecimiento.forEach(s=>{
                          me.innerHTML+=`<option value="${s.descripcion}">${s.descripcion}</option>`;
                        })
                      })
                  }
              },{
              input: {
                  type: "date",
                  name: "fecha",
                  label: "Fecha desde",
                  cols: 3,
                  value: ""
              }
          },{
            input: {
                type: "date",
                name: "fecha2",
                label: "Fecha hasta",
                cols: 3,
                value: ""
            }
          } ,{
            select: {
              type: "text",
              name: "estatus",
              label: "Estado",
              cols: 5,
              render:(me=>{
                me.innerHTML=`<option value="">Seleccione</option>`;
                let array_mostrar = [3,4,5,8,12];
                this.state.estatusTramiteCombo.forEach(s=>{
                  if(array_mostrar.includes(parseInt(s.id))){
                    me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                  }
                })
              })
            }
          }, {
              select: {
                  type: "text",
                  name: "tipo",
                  label: "Tipo establecimiento",
                  cols: 5,
                  render:(me=>{
                    me.innerHTML=`<option value="">Seleccione</option>`;
                    this.state.tipo_establecimiento.forEach(s=>{
                      me.innerHTML+=`<option value="${s.descripcion}">${s.descripcion}</option>`;
                    })
                  })
              }
          },{
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarEstablecimientos: f_busqueda_e.data() });
              this.setEstablecimientosPage(1);
            }
          }
        }
      ]
    });

    let f_busqueda_p = Api.form({
      target: "#busqueda_p",
      nombre: "busqueda_Producto",
      elementClass: "form-control",
      elements: [
          {
            input: {
                type: "text",
                name: "folio_solicitud",
                label: "Folio",
                placeHolder: "Ingresa el folio de la solicitud",
                cols: 4,
            }
          },{
            input: {
                type: "text",
                name: "nombre_comercial",
                label: "Nombre comercial",
                placeHolder: "Ingresa nombre comercial",
                cols: 4,
            }
        },{
              select: {
                  type: "text",
                  name: "nombre_servicio",
                  label: "Solicitud",
                  cols: 4,
                  render:me=>{
                    me.innerHTML=`<option value="">Seleccione</option>`;
                    this.state.accionCombo.forEach(s=>{
                      me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                    }) 
                  }
              }
          },{
          input: {
              type: "text",
              name: "titular",
              label: "Titular",
              placeHolder: "Ingresa la razón social del establecimiento",
              cols: 6,
          }
      },{
              input: {
                  type: "date",
                  name: "fecha",
                  label: "Fecha desde",
                  cols: 3,
                  value: ""
              }
          },{
            input: {
                type: "date",
                name: "fecha2",
                label: "Fecha hasta",
                cols: 3,
                value: ""
            }
          },{
            select: {
                type: "text",
                name: "tipo",
                label: "Tipo producto",
                placeHolder: "Tipo producto",
                cols: 6,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  this.state.cat_tipo_producto.forEach(s=>{
                    me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                  })
                })
            }
          },{
            select: {
                type: "text",
                name: "estatus",
                label: "Estado",
                placeHolder: "Estado",
                cols: 4,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  let array_mostrar = [1,3,4,5,6,7,8,9,10,11,12,13,14];
                  this.state.estatusTramiteCombo.forEach(s=>{
                    if(array_mostrar.includes(parseInt(s.id))){
                      me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                    }
                  })
                })
            }
          },{
            button: {
              name: "buscar",
              class: "form-control btn-orange",
              icon: "fa fa-search",
              cols: 2,
              text: "Buscar",
              click: (e) => {
                this.setState({ buscarProductos: f_busqueda_p.data() });
                this.setProductosPage(1);
              }
            }
          }
      ],
      
    });

    let f_busqueda_c = Api.form({
      target: "#busqueda_c",
      nombre: "busqueda_Constancia",
      elementClass: "form-control",
      elements: [
          {
            input: {
                type: "text",
                name: "folio_solicitud",
                label: "Folio",
                placeHolder: "Ingresa el folio de la solicitud",
                cols: 6,
            }
          },{
              input: {
                  type: "date",
                  name: "fecha",
                  label: "Fecha desde",
                  cols: 3,
                  value: ""
              }
          },{
            input: {
                type: "date",
                name: "fecha2",
                label: "Fecha hasta",
                cols: 3,
                value: ""
            }
          },{
            select: {
                type: "text",
                name: "tipo",
                label: "Tipo constancia",
                cols: 6,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  this.state.tipo_constancia.forEach(s=>{
                    me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                  })
                })
            }
          },{
            select: {
                type: "text",
                name: "estatus",
                label: "Estado",
                placeHolder: "Estado",
                cols: 4,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  let array_mostrar = [1,3,4,5,6,8,9,12];
                  this.state.estatusTramiteCombo.forEach(s=>{
                    if(array_mostrar.includes(parseInt(s.id))){
                      me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                    }
                  })
                })
            }
          },{
            button: {
              name: "buscar",
              class: "form-control btn-orange",
              icon: "fa fa-search",
              cols: 2,
              text: "Buscar",
              click: (e) => {
                this.setState({ buscarConstancias: f_busqueda_c.data() });
                this.setConstanciasPage(1);
              }
            }
          }
      ],
      
    });

    let f_busqueda_mv = Api.form({
      target: "#busqueda_mv",
      nombre: "busqueda_MedicamentoV",
      elementClass: "form-control",
      elements: [
          {
              input: {
                  type: "text",
                  name: "folio_solicitud",
                  label: "Folio",
                  placeHolder: "Ingresa el folio de la solicitud",
                  cols: 3,
              }
          },{
            select: {
                type: "text",
                name: "accion",
                label: "Solicitud",
                cols: 3,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  this.state.accionCombo.forEach(s=>{
                    if(s.id === "1" || s.id === "3003")
                    me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                  })
                })
            }
          },{
              input: {
                  type: "date",
                  name: "fecha",
                  label: "Fecha desde",
                  cols: 3,
                  value: ""
              }
          },{
            input: {
                type: "date",
                name: "fecha2",
                label: "Fecha hasta",
                cols: 3,
                value: ""
            }
          },{
            select: {
                type: "text",
                name: "estatus",
                label: "Estado",
                placeHolder: "Estado",
                cols: 10,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  let array_mostrar = [1,3,4,5,6,8,9,12,17];
                    this.state.estatusTramiteCombo.forEach(s=>{
                      if(array_mostrar.includes(parseInt(s.id))){
                        me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                      }
                    })
                })
            }
          },{
            button: {
              name: "buscar",
              class: "form-control btn-orange",
              icon: "fa fa-search",
              cols: 2,
              text: "Buscar",
              click: (e) => {
                this.setState({ buscarMedicoV: f_busqueda_mv.data() });
                this.setMedicoVeterinarioPage(1);
              }
            }
          }
      ],
    });

    let f_busqueda_cer = Api.form({
      target: "#busqueda_cer",
      nombre: "busqueda_Certificados",
      elementClass: "form-control",
      elements: [
          {
              input: {
                  type: "text",
                  name: "folio_solicitud",
                  label: "Folio",
                  placeHolder: "Ingresa el folio de la solicitud",
                  cols: 3,
              }
          },{
            select: {
                type: "text",
                name: "accion",
                label: "Solicitud",
                cols: 3,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  this.state.accionCombo.forEach(s=>{
                    if(s.id === "1" || s.id === "3003")
                    me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                  })
                })
            }
          },{
              input: {
                  type: "date",
                  name: "fecha",
                  label: "Fecha desde",
                  cols: 3,
                  value: ""
              }
          },{
            input: {
                type: "date",
                name: "fecha2",
                label: "Fecha hasta",
                cols: 3,
                value: ""
            }
          },{
            select: {
                type: "text",
                name: "estatus",
                label: "Estado",
                placeHolder: "Estado",
                cols: 10,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  let array_mostrar = [3,4,5,8,12];
                  this.state.estatusTramiteCombo.forEach(s=>{
                    if(array_mostrar.includes(parseInt(s.id))){
                      me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                    }
                  })
                })
            }
          },{
            button: {
              name: "buscar",
              class: "form-control btn-orange",
              icon: "fa fa-search",
              cols: 2,
              text: "Buscar",
              click: (e) => {
                this.setState({ buscarCertificado: f_busqueda_cer.data() });
                this.setCertificadosPage(1);
              }
            }
          }
      ],
    });
    
    let f_busqueda_pre = Api.form({
      target: "#f_busqueda_pre",
      nombre: "busqueda_Precertificados",
      elementClass: "form-control",
      elements: [
          {
              input: {
                  type: "text",
                  name: "folio_solicitud",
                  label: "Folio",
                  placeHolder: "Ingresa el folio de la solicitud",
                  cols: 3,
              }
          },{
            select: {
                type: "text",
                name: "accion",
                label: "Solicitud",
                cols: 3,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  this.state.accionCombo.forEach(s=>{
                    if(s.id === "1" || s.id === "3003")
                    me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                  })
                })
            }
          },{
              input: {
                  type: "date",
                  name: "fecha",
                  label: "Fecha desde",
                  cols: 3,
                  value: ""
              }
          },{
            input: {
                type: "date",
                name: "fecha2",
                label: "Fecha hasta",
                cols: 3,
                value: ""
            }
          },{
            select: {
                type: "text",
                name: "estatus",
                label: "Estado",
                placeHolder: "Estado",
                cols: 10,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  let array_mostrar = [3,4,5,8,12];
                  this.state.estatusTramiteCombo.forEach(s=>{
                    if(array_mostrar.includes(parseInt(s.id))){
                      me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                    }
                  })
                })
            }
          },{
            button: {
              name: "buscar",
              class: "form-control btn-orange",
              icon: "fa fa-search",
              cols: 2,
              text: "Buscar",
              click: (e) => {
                this.setState({ buscarPrecertificado: f_busqueda_pre.data() });
                this.setPrecertificadosPage(1);
              }
            }
          }
      ],
    });

    let f_busqueda_prece = Api.form({
      target: "#f_busqueda_prece",
      nombre: "busqueda_Precertificados",
      elementClass: "form-control",
      elements: [
          {
              input: {
                  type: "text",
                  name: "folio_solicitud",
                  label: "Folio",
                  placeHolder: "Ingresa el folio de la solicitud",
                  cols: 3,
              }
          },{
            select: {
                type: "text",
                name: "accion",
                label: "Solicitud",
                cols: 3,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  this.state.accionCombo.forEach(s=>{
                    if(s.id === "1" || s.id === "3003")
                    me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                  })
                })
            }
          }, {
            input: {
                type: "text",
                name: "razon_social",
                label: "Razón social",
                placeHolder: "Ingresa la razón social del establecimiento",
                cols: 3,
              }
          }, {
            input: {
                type: "number",
                name: "cantidad",
                label: "Cantidad",
                placeHolder: "Ingresa la cantidad de precertificados y/o ...",
                cols: 3,
              }
          },{
              input: {
                  type: "date",
                  name: "fecha",
                  label: "Fecha desde",
                  cols: 3,
                  value: ""
              }
          },{
            input: {
                type: "date",
                name: "fecha2",
                label: "Fecha hasta",
                cols: 3,
                value: ""
            }
          },{
            select: {
                type: "text",
                name: "estatus",
                label: "Estado",
                placeHolder: "Estado",
                cols: 4,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione</option>`;
                  let array_mostrar = [3,4,5,8,12,17];
                  this.state.estatusTramiteCombo.forEach(s=>{
                    if(array_mostrar.includes(parseInt(s.id))){
                      me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                    }
                  })
                })
            }
          },{
            button: {
              name: "buscar",
              class: "form-control btn-orange",
              icon: "fa fa-search",
              cols: 2,
              text: "Buscar",
              click: (e) => {
                this.setState({ buscarPrecertificadoce: f_busqueda_prece.data() });
                this.setPrecertificadosCEPage(1);
              }
            }
          }
      ],
    });
  }

  setSolicitudesPage(page) {
    this.setState({ workingGrid: true });
    
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getRegenteRequests?page=" + page + src).then((r) => { 
      this.setState({
        regentes: r.data,
        paginas: r.last_page,
        registros: r.total,
        paginaActual: r.current_page,
        workingGrid: false,
      });
    });
  }

  setEstablecimientosPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscarEstablecimientos;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getPayOrderEstUser?page=" + page + src).then((r) => {
      this.setState({
        establecimientos: r.data,
        paginas_e: r.last_page,
        registros_e: r.total,
        paginaActual_e: r.current_page,
        workingGrid: false,
      });
    });
  }

  setProductosPage(page) {
    this.setState({ workingGrid: true });
    
    let search = this.state.buscarProductos;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getPayOrderProUser?page=" + page + src).then((m) => {
      this.setState({
        productos: m.data,
        paginas_p: m.last_page,
        registros_p: m.total,
        paginaActual_p: m.current_page,
        workingGrid: false,
      });
    });
  }

  setConstanciasPage(page) {
    this.setState({ workingGrid: true });
    
    let search = this.state.buscarConstancias;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getConstancias?page=" + page + src).then((m) => {
      this.setState({
        constancias: m.data,
        paginas_c: m.last_page,
        registros_c: m.total,
        paginaActual_c: m.current_page,
        workingGrid: false,
      });
    });
  }

  setMedicoVeterinarioPage(page) {
    this.setState({ workingGrid: true });
        
    let search = this.state.buscarMedicoV;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getSolMedicoVetUser?page=" + page + src).then((m) => {
      this.setState({
        medico_veterinario: m.data,
        paginas_mv: m.last_page,
        registros_mv: m.total,
        paginaActual_mv: m.current_page,
        workingGrid: false,
      });
    });
  }

  setCertificadosPage(page) {
    this.setState({ workingGrid: true });
        
    let search = this.state.buscarCertificado;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getPayOrderCertificateUser?page=" + page + src).then((m) => {
      this.setState({
        certificados: m.data,
        paginas_cer: m.last_page,
        registros_cer: m.total,
        paginaActual_cer: m.current_page,
        workingGrid: false,
      });
    });
  }

  setPrecertificadosPage(page){
    this.setState({ workingGrid: true });
        
    let search = this.state.buscarPrecertificado;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getPayOrderPreCertificateUser?page=" + page + src).then((m) => {
      this.setState({
        precertificados: m.data,
        paginas_pre: m.last_page,
        registros_pre: m.total,
        paginaActual_pre: m.current_page,
        workingGrid: false,
      });
    });
  }

  setPrecertificadosCEPage(page) {
    this.setState({ workingGrid: true });
        
    let search = this.state.buscarPrecertificadoce;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getPrecertificadoCEClient?page=" + page + src).then((m) => {
      this.setState({
        precertificadosCE: m.data,
        paginas_prece: m.last_page,
        registros_prece: m.total,
        paginaActual_prece: m.current_page,
        workingGrid: false,
      });
    });
  }

  handleSolicitudPage(e) {
    this.setSolicitudesPage(e.target.value);
  }

  handleEstablecimientoPage(e){
    this.setEstablecimientosPage(e.target.value);  
  }

  handleProductoPage(e){
    this.setProductosPage(e.target.value);  
  }

  handleConstanciasPage(e){
    this.setConstanciasPage(e.target.value);  
  }

  handleMedicoVeterinarioPage(e){
    this.setMedicoVeterinarioPage(e.target.value);  
  }

  handleCertificadosPage(e){
    this.setCertificadosPage(e.target.value);  
  }

  handlePreCertificadosPage(e){
    this.setPreCertificadosPage(e.target.value);  
  }

  handlePreCertificadosCEPage(e){
    this.setPrecertificadosCEPage(e.target.value);
  }

  handleClick(e) {
    this.setState({
      modalOrden: true,
      working: true,
    });

    Api.fetch("app/getPayOrderforClient", { id: e.target.id }, "POST").then(
      (o) => {
        if (o) {
          this.setState({
            orden: o,
            working: false,
          });
        }
      }
    );
  }

  handleClickEstablecimiento(e) {
    this.setState({
      modalOrden: true,
      working: true,
    });
    
    Api.fetch("app/getPayOrderforEstablecimiento", { id: e.target.id,servicio:e.target.dataset.ser }, "POST").then(
      (o) => {
          this.setState({
            orden: o,
            working: false,
          });
          
      }
    );
  }

  handleClickProductos(e) {
    this.setState({
      modalOrden: true,
      working: true,
    });
    
    Api.fetch("app/getPayOrderforProducto", { id: e.target.id }, "POST").then(
      (o) => {
          this.setState({
            orden: o,
            working: false,
          });
          
      }
    );
  }

  handleClickConstancias(e) {
    this.setState({
      modalOrden: true,
      working: true,
    });
    
    Api.fetch("app/getPayOrderforConstancia", { id: e.target.id }, "POST").then(
      (o) => {
          this.setState({
            orden: o,
            working: false,
          });
          
      }
    );
  }

  handleClickCorrection(e) {
    this.props.history.push("/solicitud/inscripcion-regente");
  }

  handleMVCorrection(e){
    this.props.history.push("/solicitud/inscripcion-medico-veterinario");
  }

  handleClose() {
    this.setState({
      modalOrden: false,
    });
  }

  handleClickDocRefrenda(e){
    let orden_id = e.target.id;
    //let orden = this.state.orden;

    

    Api.loading(true);
    Api.fetch("app/getPayOrderforProducto", { id: orden_id }, "POST").then(
      (o) => {
          this.setState({
            orden: o,
          });

          let solicitud_id = o.solicitud_id;
          Api.fetch("app/getDocObligatorioRefrenda?solicitud_id="+solicitud_id).then(files=>{
            Api.loading(false);
            let uploadDocs = Api.upload({
                target:"#cargaDocs",
                required:files.documentos,
                ok:files.aprobados,
                post:"app/setProductDocs",
                exts:".jpg, .jpeg, .png, .pdf",
                params: o,
                onFinish:r=>{
                    Swal.fire({
                        title:"Carga de documentos",
                        html:"Carga completa con éxito",
                        icon:"success"
                    });
    
                    modalarchivos.close();
                    this.setProductosPage(this.state.paginaActual_p);
                    //mi_grid.go(0); // ir a la pagina actual - refrescar el grid
                }
           });
  
           let modalarchivos = Api.modal({
               title:"Documentación requerida",
               html:uploadDocs 
           });
  
           });      
        }
    );

  }

  handleClickCertificados(e) {
    this.setState({
      modalOrden: true,
      working: true,
    });
    
    Api.fetch("app/getPayOrderCertificado", { id: e.target.id }, "POST").then(
      (o) => {
          this.setState({
            orden: o,
            working: false,
          });
      }
    );
  }

  handleClickPrecertificadoCE(e){
    this.setState({
      modalOrden: true,
      working: true,
    });
    
    Api.fetch("app/getPayOrderforCreditosPrecertificados", { id: e.target.id }, "POST").then(
      (o) => {
          this.setState({
            orden: o,
            working: false,
          });
      }
    );
  }

  handleClickPrecertificados(e){
    this.setState({
      modalOrden: true,
      working: true,
    });
    
    Api.fetch("app/getPayOrderforCreditosPrecertificado", { id: e.target.id }, "POST").then(
      (o) => {
          this.setState({
            orden: o,
            working: false,
          });
      }
    );
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li> 
          <li className="breadcrumb-item">
          <Link to="/tramites">Consulta de trámite</Link>
          </li>
        </ol>
        <h1 className="page-header">
            Consulta de trámites
        </h1>
        <div className="row">
          <div className="col-xl-12">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === "1" })}
                  onClick={() => {
                    this.toggleTab("1");
                  }}
                >
                  <span className="d-sm-none">
                    REGENTES
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    REGENTES
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === "2" })}
                  onClick={() => {
                    this.toggleTab("2");
                  }}
                >
                  <span className="d-sm-none">
                    ESTABLECIMIENTOS 
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_e}
                    </span>
                  </span>

                  <span className="d-sm-block d-none">
                    ESTABLECIMIENTOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_e}
                    </span>
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === "3" })}
                  onClick={() => {
                    this.toggleTab("3");
                  }}
                >
                  <span className="d-sm-none">
                    PRODUCTOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_p}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    PRODUCTOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_p}
                    </span>
                  </span>
                </NavLink>
              </NavItem>
              
            <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === "4" })}
                  onClick={() => {
                    this.toggleTab("4");
                  }}
                >
                  <span className="d-sm-none">
                     CONSTANCIAS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_c}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    CONSTANCIAS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_c}
                    </span>
                  </span>
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === "5" })}
                  onClick={() => {
                    this.toggleTab("5");
                  }}
                >
                  <span className="d-sm-none">
                    MÉDICO VETERINARIO
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_mv}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    MÉDICO VETERINARIO
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_mv}
                    </span>
                  </span>
                </NavLink>
              </NavItem> 

              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === "6" })}
                  onClick={() => {
                    this.toggleTab("6");
                  }}
                >
                  <span className="d-sm-none">
                    CERTIFICADOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_cer}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    CERTIFICADOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_cer}
                    </span>
                  </span>
                </NavLink>
              </NavItem> 

              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === "7" })}
                  onClick={() => {
                    this.toggleTab("7");
                  }}
                >
                  <span className="d-sm-none">
                    PRECERTIFICADOS Y/O CONSTANCIAS DE EXPORTACIÓN
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_prece}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    PRECERTIFICADOS Y/O CONSTANCIAS DE EXPORTACIÓN
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_prece}
                    </span>
                  </span>
                </NavLink>
              </NavItem> 

              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === "8" })}
                  onClick={() => {
                    this.toggleTab("8");
                  }}
                >
                  <span className="d-sm-none">
                    PRECERTIFICADOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_pre}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    PRECERTIFICADOS 
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros_pre}
                    </span>
                  </span>
                </NavLink>
              </NavItem> 
            </Nav>

            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <fieldset>
                  <div id="busqueda_r"></div>
                </fieldset>
                <div className="table-responsive">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">FOLIO</th>
                        <th className="text-center">SOLICITUD</th>
                        <th className="text-center">FECHA</th>
                        <th className="text-center">TIPO REGENTE</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center">OBSERVACIÓN</th>
                        <th className="text-center">ORDEN DE PAGO</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.regentes.map((reg, inde) => (
                        <tr key={inde}>
                          <td className="text-center">{reg.folio_solicitud}</td>
                          <td className="text-center">{reg.accion}</td>
                          <td className="text-center">
                            {format(new Date(reg.fecha_solicitud), "dd/MM/yyyy")}
                            </td>
                          <td className="text-center">{reg.tipo}</td>

                          <td className="text-center">
                            {reg.estatus !== null && reg.estatus === "6" ? ( //Correccion
                              <button
                                onClick={this.handleClickCorrection}
                                id={reg.id}
                                data-reg={reg.id}
                                className="btn btn-warning"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Se necesita corrección"
                              >
                                <i
                                  className="fa fa-exclamation-triangle"
                                  id={reg.id}
                                ></i>
                              </button>
                            ) : (
                              reg.estatus_name
                            )}
                          </td>
                            <td className="text-center"
                            title={ reg.observacion_s }
                          >
                            {(reg.observacion_s.length > 50 ? reg.observacion_s.substring(0, 50).toUpperCase() +
                            "..." : reg.observacion_s)}
                          </td>
                          <td className="text-center">
                            {reg.existe !== null && ( reg.estatus_pago_id ==="1" || reg.estatus_pago_id === "8" ) ? ( //en espera de pago
                              <button
                                onClick={this.handleClick}
                                id={reg.id}
                                data-reg={reg.id}
                                className="btn btn-info"
                              >
                                <i className="fa fa-print" id={reg.id}></i>
                              </button>
                            ) : reg.existe !== null && (reg.estatus_pago_id === "5" || reg.estatus_pago_id === "3")? ( //ValidadaSGI o aceptada
                              "Referencia: " + reg.clave_referencia
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setSolicitudesPage(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual - 1 > 0) {
                              this.setSolicitudesPage(
                                this.state.paginaActual - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual} de {this.state.paginas}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas >=
                              this.state.paginaActual + 1
                            ) {
                              this.setSolicitudesPage(
                                this.state.paginaActual + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setSolicitudesPage(this.state.paginas);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Ver Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.setSolicitudesPage}
                        type="number"
                        min="1"
                        max={this.state.paginas}
                        value={this.state.paginaActual}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </TabPane>
              <TabPane tabId="2">
                <fieldset>
                  <div id="busqueda_e"></div>
                </fieldset>
                <div className="table-responsive">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                    <tr>
                        <th className="text-center">FOLIO</th>
                        <th className="text-center">SOLICITUD</th>
                        <th className="text-center">RAZÓN SOCIAL</th>
                        <th className="text-center">TIPO ESTABLECIMIENTO</th>
                        <th className="text-center">ACTIVIDAD</th>
                        <th className="text-center">FECHA</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center">OBSERVACIÓN</th>
                        {/*<th className="text-center">FECHA APROBACIÓN</th>*/}
                        <th className="text-center">ORDEN DE PAGO</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.establecimientos.map((est, index) => (
                        <tr key={index}>
                          <td className="text-center">{est.folio_solicitud}</td>
                          <td className="text-center">{est.nombre_servicio}</td>
                          <td className="text-center">{est.razon_social}</td>
                          <td className="text-center" title={est.tipo}>{est.tipo.substr(0,100)+'...'}</td>
                          <td className="text-center" title={est.actividad}>{est.actividad.substr(0,100)+'...'}</td>
                          <td className="text-center">
                            {format(new Date(est.fecha_orden), "dd/MM/yyyy")}
                            </td>
                          <td className="text-center">{est.estatus}</td>
                          <td title={
                              est.estatus_id === "5" ? est.observacion_s : ""
                            }
                          >
                            {est.estatus_id === "5" ?
                            (est.observacion_s.length > 50 ? est.observacion_s.substring(0, 50).toUpperCase() +
                            "..." : est.observacion_s)
                            : ""}
                            </td>
                            {/*<td className="text-center">{ est.fecha_aprueba_sinaip !== null?
                            format(new Date(est.fecha_aprueba_sinaip), "dd/MM/yyyy"): ""}</td>*/}
                          <td className="text-center">
                            {est.estatus_id === "8" ? (//En espera
                              <button
                                onClick={this.handleClickEstablecimiento}
                              id={est.id}
                              data-est={est.id}
                              data-ser={est.nombre_servicio}
                              className="btn btn-info"
                            >
                              <i className="fa fa-print"
                              data-est={est.id}
                              data-ser={est.nombre_servicio}
                              id={est.id}></i>
                            </button>
                          ) : ( //pagado
                            "Referencia: " + est.clave_referencia
                          ) 
                          }
                          </td>
                        
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setEstablecimientosPage(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual_e - 1 > 0) {
                              this.setEstablecimientosPage(
                                this.state.paginaActual_e - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual_e} de {this.state.paginas_e}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas_e >=
                              this.state.paginaActual_e + 1
                            ) {
                              this.setEstablecimientosPage(
                                this.state.paginaActual_e + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setEstablecimientosPage(this.state.paginas_e);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Ver Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.setEstablecimientosPage}
                        type="number"
                        min="1"
                        max={this.state.paginas_e}
                        value={this.state.paginaActual_e}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </TabPane> 
              <TabPane tabId="3">
                <fieldset>
                  <div id="busqueda_p"></div>
                </fieldset>
                <div className="table-responsive">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">FOLIO</th>
                        <th className="text-center">SOLICITUD</th>
                        <th className="text-center">FECHA</th>
                        <th className="text-center">NOMBRE COMERCIAL</th>
                        <th className="text-center">TIPO PRODUCTO</th>
                        <th className="text-center">TITULAR</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center">OBSERVACIÓN</th>
                        <th className="text-center">ORDEN DE PAGO</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.productos.map((pro, index) => (
                        <tr key={index}>
                          <td className="text-center">{pro.folio_solicitud}</td>
                          <td className="text-center">{pro.nombre_servicio}</td>
                          <td className="text-center">
                            {format(new Date(pro.fecha_orden), "dd/MM/yyyy")}
                            </td>
                          <td title={pro.nombre_comercial} className="text-center" >{
                          pro.titular !== undefined ?
                          String(pro.nombre_comercial).slice(0,100):pro.nombre_comercial}</td>
                          <td title={pro.tipo_producto} className="text-center" >{pro.tipo_producto!==null?pro.tipo_producto.slice(0,200):""}</td>
                          <td title={pro.titular} className="text-center" >{pro.titular !== undefined ?
                          pro.titular.slice(0,200)
                        :pro.titular
                        }</td>
                          <td className="text-center">{pro.estatus}</td>
                          <td 
                            title={
                              pro.estatus_id === "5" ? pro.observacion_s : ""
                            }
                          >
                            {pro.estatus_id === "5" ?
                            (pro.observacion_s.length > 50 ? pro.observacion_s.substring(0, 50).toUpperCase() +
                            "..." : pro.observacion_s)
                            : ""}
                            </td>
                          <td className="text-center">
                            {pro.estatus_id === "8" ? (//En espera
                              <button
                                onClick={this.handleClickProductos}
                              id={pro.id}
                              data-pro={pro.id}
                              className="btn btn-info"
                            >
                              <i className="fa fa-print" id={pro.id}></i>
                            </button>
                          ) : (
                            (pro.estatus_id === "3" || pro.estatus_id === "5")?  //pagado o aceptado
                              "Referencia: " + pro.clave_referencia
                            : "Referencia: " + pro.clave_referencia/*(pro.estatus_id === "7" && pro.tramite_id !=="8" && pro.tramite_id === "11" ? ( //en espera de documentacion
                              <button
                                onClick={this.handleClickDocRefrenda}
                                id={pro.id}
                                data-pro={pro.id}
                                className="btn btn-info"
                              >
                                <i className="fa fa-paperclip" id={pro.id}></i>
                              </button>
                              ) : "Referencia: " + pro.clave_referencia)*/
                          )
                          }
                          </td>
                        
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setProductosPage(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual_p - 1 > 0) {
                              this.setProductosPage(
                                this.state.paginaActual_p - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual_p} de {this.state.paginas_p}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas_p >=
                              this.state.paginaActual_p + 1
                            ) {
                              this.setProductosPage(
                                this.state.paginaActual_p + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setProductosPage(this.state.paginas_p);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Ver Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.setProductosPage}
                        type="number"
                        min="1"
                        max={this.state.paginas_p}
                        value={this.state.paginaActual_p}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </TabPane>
              <TabPane tabId="4">
                <fieldset>
                  <div id="busqueda_c"></div>
                </fieldset>
                <div className="table-responsive">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">FOLIO</th>
                        <th className="text-center">SOLICITUD</th>
                        <th className="text-center">FECHA</th>
                        <th className="text-center">TIPO CONSTANCIA</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center">OBSERVACIÓN</th>
                        <th className="text-center">ORDEN DE PAGO</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.constancias.map((cons, index) => (
                        <tr key={index}>
                          <td className="text-center">{cons.folio_solicitud}</td>
                          <td className="text-center">{cons.nombre_servicio}</td>
                          <td className="text-center">
                            {format(new Date(cons.fecha_solicitud), "dd/MM/yyyy")}
                            </td>
                          <td className="text-center">{cons.tipo_constancia}</td>
                          <td className="text-center">{cons.estatus}</td> 
                          <td 
                            title={
                              cons.estatus_id === "3" ? cons.observacion_s : ""
                            }
                          >
                            {cons.estatus_id === "3" ?
                            (cons.observacion_s.length > 50 ? cons.observacion_s.substring(0, 50).toUpperCase() +
                            "..." : cons.observacion_s)
                            : ""}
                            </td>   
                          <td className="text-center">
                            {cons.estatus_id === "8" ? (//En espera
                                <button
                                  onClick={this.handleClickConstancias}
                                id={cons.id}
                                data-pro={cons.id}
                                className="btn btn-info"
                              >
                                <i className="fa fa-print" id={cons.id}></i>
                              </button>
                            ) : ( //pagado
                              "Referencia: " + cons.clave_referencia
                            )
                            }
                          </td>                 
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setConstanciasPage(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual_c - 1 > 0) {
                              this.setConstanciasPage(
                                this.state.paginaActual_c - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual_c} de {this.state.paginas_c}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas_c >=
                              this.state.paginaActual_c + 1
                            ) {
                              this.setConstanciasPage(
                                this.state.paginaActual_c + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setConstanciasPage(this.state.paginas_c);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Ver Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.setConstanciasPage}
                        type="number"
                        min="1"
                        max={this.state.paginas_c}
                        value={this.state.paginaActual_c}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </TabPane> 
              <TabPane tabId="5">
                <fieldset>
                  <div id="busqueda_mv"></div>
                </fieldset>
                <div className="table-responsive">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">FOLIO</th>
                        <th className="text-center">SOLICITUD</th>
                        <th className="text-center">FECHA</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center">OBSERVACIÓN</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.medico_veterinario.map((mv, inde) => (
                        <tr key={inde}>
                          <td className="text-center">{mv.folio_solicitud}</td>
                          <td className="text-center">{mv.tramite}</td>
                          <td className="text-center">
                            {format(new Date(mv.fecha_solicitud), "dd/MM/yyyy")}
                            </td>
                          
                          <td className="text-center">
                            {mv.estatus !== null && mv.estatus_id === "6" ? ( //Correccion
                              <button
                                onClick={this.handleMVCorrection}
                                id={mv.medico_id}
                                data-solicitud-id={mv.solicitud_id}
                                className="btn btn-warning"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Se necesita corrección"
                              >
                                <i
                                  className="fa fa-exclamation-triangle"
                                  id={mv.medico_id}
                                ></i>
                              </button>
                            ) : (
                              mv.estatus_name
                            )}
                          </td>
                          <td 
                            title={
                              mv.estatus_id === "3" ? mv.observacion_s : ""
                            }
                          >
                            {mv.estatus_id === "3" ?
                            (mv.observacion_s.length > 50 ? mv.observacion_s.substring(0, 50).toUpperCase() +
                            "..." : mv.observacion_s)
                            : ""}
                            </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setMedicoVeterinarioPage(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual_mv - 1 > 0) {
                              this.setMedicoVeterinarioPage(
                                this.state.paginaActual_mv - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual_mv} de {this.state.paginas_mv}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas_mv >=
                              this.state.paginaActual_mv + 1
                            ) {
                              this.setMedicoVeterinarioPage(
                                this.state.paginaActual_mv + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setMedicoVeterinarioPage(this.state.paginas_mv);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Ver Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.setMedicoVeterinarioPage}
                        type="number"
                        min="1"
                        max={this.state.paginas_mv}
                        value={this.state.paginaActual_mv}
                      />
                    </div>
                  </div>
                </div>
              </TabPane>
              <TabPane tabId="6">
                <fieldset>
                  <div id="busqueda_cer"></div>
                </fieldset>
                <div className="table-responsive">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">FOLIO</th>
                        <th className="text-center">SOLICITUD</th>
                        <th className="text-center">TIPO CERTIFICADO</th>
                        <th className="text-center">FECHA</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center">ORDEN DE PAGO</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.certificados.map((cer, index) => (
                        <tr key={index}>
                          <td className="text-center">{cer.folio_solicitud}</td>
                          <td className="text-center">{cer.tramite}</td>
                          <td className="text-center">{cer.tipo_certificado}</td>
                          <td className="text-center">
                            {format(new Date(cer.fecha_solicitud), "dd/MM/yyyy")}
                            </td>
                            <td className="text-center">{cer.estatus}</td>
                            <td className="text-center">
                            {cer.estatus_id === "8" ? (//En espera
                                <button
                                  onClick={this.handleClickCertificados}
                                id={cer.id}
                                data-pro={cer.id}
                                className="btn btn-info"
                              >
                                <i className="fa fa-print" id={cer.id}></i>
                              </button>
                            ) :
                              "Referencia: " + cer.clave_referencia
                            }
                          </td>

                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setCertificadosPage(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual_cer - 1 > 0) {
                              this.setCertificadosPage(
                                this.state.paginaActual_cer - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual_cer} de {this.state.paginas_cer}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas_cer >=
                              this.state.paginaActual_cer + 1
                            ) {
                              this.setCertificadosPage(
                                this.state.paginaActual_cer + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setCertificadosPage(this.state.paginas_cer);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Ver Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.setCertificadosPage}
                        type="number"
                        min="1"
                        max={this.state.paginas_cer}
                        value={this.state.paginaActual_cer}
                      />
                    </div>
                  </div>
                </div>
              </TabPane>
              <TabPane tabId="7">
                <fieldset>
                  <div id="f_busqueda_prece"></div>
                </fieldset>
                <div className="table-responsive">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">FOLIO</th>
                        <th className="text-center">SOLICITUD</th>
                        <th className="text-center">FECHA</th>
                        <th className="text-center">ESTABLECIMIENTO</th>
                        <th className="text-center">CANTIDAD</th>
                        <th className="text-center">OBSERVACIÓN</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center">ORDEN DE PAGO</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.precertificadosCE.map((pre, index) => (
                        <tr key={index}>
                          <td className="text-center">{pre.folio_solicitud}</td>
                          <td className="text-center">{pre.accion}</td>
                          <td className="text-center">
                            {format(new Date(pre.fecha_solicitud), "dd/MM/yyyy")}
                          </td>
                          <td className="text-center">{pre.razon_social}</td>
                          <td className="text-center">{pre.cantidad}</td>
                          <td className="text-center">{pre.observacion}</td>
                          <td className="text-center">{pre.descripcion}</td>
                          <td className="text-center">
                            {pre.estatus_tramite_id === "8" ? (//En espera
                                <button
                                  onClick={this.handleClickPrecertificadoCE}
                                  id={pre.id}
                                  className="btn btn-info"
                                >
                                <i className="fa fa-print" id={pre.id}></i>
                                </button>
                              ) : "Referencia: " + pre.clave_referencia
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setPrecertificadosCEPage(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual_prece - 1 > 0) {
                              this.setPrecertificadosCEPage(
                                this.state.paginaActual_prece - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual_prece} de {this.state.paginas_prece}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas_prece >=
                              this.state.paginaActual_prece + 1
                            ) {
                              this.setPrecertificadosCEPage(
                                this.state.paginaActual_prece + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setPrecertificadosCEPage(this.state.paginas_prece);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Ver Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.setPrecertificadosCEPage}
                        type="number"
                        min="1"
                        max={this.state.paginas_prece}
                        value={this.state.paginaActual_prece}
                      />
                    </div>
                  </div>
                </div>
              </TabPane>
              <TabPane tabId="8">
                <fieldset>
                  <div id="f_busqueda_pre"></div>
                </fieldset>
                <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">FOLIO</th>
                        <th className="text-center">SOLICITUD</th>
                        <th className="text-center">FECHA</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center">ORDEN DE PAGO</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.precertificados.map((pre, index) => (
                        <tr key={index}>
                          <td className="text-center">{pre.folio_solicitud}</td>
                          <td className="text-center">{pre.tramite}</td>
                          <td className="text-center">
                            {format(new Date(pre.fecha_solicitud), "dd/MM/yyyy")}
                            </td>
                            <td className="text-center">{pre.estatus}</td>
                            <td className="text-center">
                            {pre.estatus_pago_id === "8" ? (//En espera
                                <button
                                  onClick={this.handleClickPrecertificados}
                                id={pre.id}
                                data-pro={pre.id}
                                className="btn btn-info"
                              >
                                <i className="fa fa-print" id={pre.id}></i>
                              </button>
                            ): ("Referencia: " + pre.clave_referencia )
                            }
                          </td>

                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setPrecertificadosPage(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual_pre - 1 > 0) {
                              this.setPrecertificadosPage(
                                this.state.paginaActual_pre - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual_pre} de {this.state.paginas_pre}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas_pre >=
                              this.state.paginaActual_pre + 1
                            ) {
                              this.setPrecertificadosPage(
                                this.state.paginaActual_pre + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setPrecertificadosPage(this.state.paginas_pre);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Ver Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.setPrecertificadosPage}
                        type="number"
                        min="1"
                        max={this.state.paginas_pre}
                        value={this.state.paginaActual_pre}
                      />
                    </div>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>
            <PagoOrden
            modalOrden={this.state.modalOrden}
            working={this.state.working}
            orden={this.state.orden}
            date={this.state.date}
            change={this.handleClose}
          />
        </div>
        <div className="hide">
                      <fieldset id="cargaDocs"></fieldset>
                </div>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <Tramites auth={auth} history={history} {...props} />;
};
